import { panelCellGroups } from "./panelTopology";
import { topologyErrors } from "./detailedShading";

// Educational connection highlighting, not an electrical operating-point solve.
// Include every protected group sharing a diode with a touched cell. Without
// bypass diodes, highlight only the unprotected series branch that was touched.
export function panelShadowPreview(topology, shadow) {
  const empty = { shadedCells: new Set(), affectedCells: new Set(), diodes: [] };
  if (topologyErrors(topology).length || !shadow || shadow.width <= 0 || shadow.height <= 0) return empty;
  const rows = Number(topology.cellRows), columns = Number(topology.cellColumns);
  const groups = panelCellGroups(topology);
  const shadedCells = new Set();
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < columns; col++) {
      const overlapX = Math.min((col + 1) / columns, shadow.x + shadow.width) - Math.max(col / columns, shadow.x);
      const overlapY = Math.min((row + 1) / rows, shadow.y + shadow.height) - Math.max(row / rows, shadow.y);
      if (overlapX > 1e-10 && overlapY > 1e-10) shadedCells.add(row * columns + col);
    }
  }
  const touched = groups.filter(group => group.cells.some(cell => shadedCells.has(cell)));
  const diodes = [...new Set(touched.map(group => group.diode).filter(Boolean))].sort((a, b) => a - b);
  const branches = new Set(touched.map(group => group.branch));
  const affected = groups.filter(group => group.diode ? diodes.includes(group.diode) : branches.has(group.branch));
  return { shadedCells, affectedCells: new Set(affected.flatMap(group => group.cells)), diodes };
}
